export default __webpack_public_path__ + "static/media/company-details-img.17bf094d.png";